import { Box, Button, Flex, FormControl, FormLabel, GridItem, Input, Select, SimpleGrid } from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import { useEffect, useState } from "react";
import { useLoading } from "Providers/LoadingProvider";
import { Field, Form, Formik } from "formik";
import StationsApi from "Api/StationsApi";
import { FaSearch } from "react-icons/fa";
import PrintMode from "components/Buttons/PrintMode";
import Favorites from "Helpers/Favorites";
import { StationDataBody } from "../Admin/Stations";

function StationDataReport() {
    const [ filter, setFilter] = useState({});

    async function loadData(station, day) {
        setFilter({station, day});
    }

    return (
        <Card overflowX="auto">
            <CardBody>
                <Flex direction="column" w="100%">
                    <Box mb={4}>
                        <FormFilter loadData={loadData} />
                    </Box>
                    <StationDataBody
                        stationId={filter?.station?.id}
                        defaultDay={filter.day}
                        isEmbeded
                    />
                    {
                        filter?.station?.provider == 'INMET' &&
                        <Box mb={2} w="100%" textAlign={"center"} fontSize="sm">
                            Fonte de dados: INMET
                        </Box>
                    }
                    <PrintMode />
                </Flex>
            </CardBody>
        </Card>
    );
}

function FormFilter({ loadData }) {
    const [stations, setStations] = useState([]);
    const loading = useLoading();
    const favorites = Favorites.get();


    useEffect(() => {
        loadStationOptions();
    }, []);

    async function loadStationOptions() {
        loading.show();
        let response = await StationsApi.options();
        setStations(response.json);
        loading.hide();
    }

    async function submitHandle(values) {
        loadData(stations.find(x => x.id == values.station_id), values.day);
    }

    return (
        <Formik onSubmit={submitHandle} initialValues={{ station_id: null, day: '' }} enableReinitialize={true}>
            {props => (
                <Form id="reportFilterForm">
                    <Flex flexDirection="row" flexWrap w="100%">
                        <SimpleGrid w="100%" columns={{ sm: 1, lg: 12 }} gap={4}>
                            <GridItem colSpan={{ sm: 1, lg: 6 }}>
                                <Field name="station_id">
                                    {({ field, form }) => (
                                        <FormControl isRequired>
                                            <FormLabel mb="0" htmlFor="station_id" fontWeight="normal">Estação:</FormLabel>
                                            <Select id="station_id" {...field} borderRadius="10px" fontSize="md" placeholder="Selecione a Estação...">
                                                {
                                                    !favorites || !favorites.length ?
                                                        (
                                                            stations?.map(station => (
                                                                <option value={station.id}>{station.text}</option>
                                                            ))
                                                        )
                                                        :
                                                        (
                                                            <>
                                                                <optgroup key="favorites" label="Estações Favoritas">
                                                                    {stations?.map(station => {
                                                                        if (favorites.includes(station.identifier))
                                                                            return (<option value={station.id}>{station.text}</option>);
                                                                        else
                                                                            return "";
                                                                    })}
                                                                </optgroup>
                                                                <optgroup key="others" label="Outras Estações">
                                                                    {stations?.map(station => {
                                                                        if (!favorites.includes(station.identifier))
                                                                            return (<option value={station.id}>{station.text}</option>);
                                                                        else
                                                                            return "";
                                                                    })}
                                                                </optgroup>
                                                            </>
                                                        )
                                                }
                                            </Select>
                                        </FormControl>
                                    )}
                                </Field>
                            </GridItem>
                            <GridItem colSpan={{ sm: 1, lg: 4 }}>
                                <Field name="day">
                                    {({ field, form }) => (
                                        <FormControl>
                                            <FormLabel mb="0" htmlFor="day" fontWeight="normal">Dia:</FormLabel>
                                            <Input id="day" {...field} borderRadius="10px" fontSize="md" type="date" />
                                        </FormControl>
                                    )}
                                </Field>
                            </GridItem>

                            <GridItem colSpan={{ sm: 1, lg: 2 }}>
                                <Button w="100%" type='submit' form='reportFilterForm' colorScheme="blue" mt={{ lg: 6 }} leftIcon={<FaSearch />}>
                                    Buscar
                                </Button>
                            </GridItem>
                        </SimpleGrid>
                    </Flex>
                </Form>
            )}
        </Formik>
    );
}

export default StationDataReport;
